import { useI18n } from "@wojo/localization";
import { Text } from "@wojo/ui";
import cn from "clsx";
import pluralize from "pluralize";
import React, { HtmlHTMLAttributes } from "react";
import { FiCircle } from "react-icons/fi";
import styles from "./Itinerary.module.scss";

export type ItinerarySectionTitleProps =
    HtmlHTMLAttributes<HTMLHeadingElement> & {
        isTopLevel?: boolean | null;
        nbNights?: number | null;
        title?: string | null;
    };

export const ItinerarySectionTitle: React.FC<ItinerarySectionTitleProps> = ({
    isTopLevel,
    nbNights,
    title,
    ...headingProps
}) => {
    const { productPage } = useI18n("productPage");
    const isOvernight = !!nbNights && nbNights > 0;
    const nightsLabel = pluralize(
        productPage.itinerary.overnightLabel.l({
            nbNights: `${nbNights}`,
        }),
        nbNights ?? undefined,
    );

    if (!title) {
        return null;
    }

    return (
        <Text.Heading
            {...headingProps}
            order={isOvernight ? "4" : "5"}
            tag={isTopLevel ? "h3" : "h4"}
            className={cn({
                [styles["day-section-title"]]: isTopLevel,
                [styles["day-overnight-title"]]: isOvernight,
                [styles["day-title"]]: !isOvernight,
            })}
            aria-label={!!nbNights ? `${title} for ${nightsLabel}` : undefined}
        >
            {isTopLevel && (
                <FiCircle
                    className={styles["day-marker"]}
                    aria-hidden
                    role="img"
                />
            )}
            {title}
            {!!nbNights && (
                <Text.Body
                    tag="span"
                    style={{
                        fontSize: "inherit",
                        display: "inline",
                        paddingLeft: "var(--g-spacing-md)",
                        marginLeft: "var(--g-spacing-md)",
                        borderLeft:
                            "1px solid var(--s-color-separator-standard)",
                    }}
                    aria-hidden
                >
                    {nightsLabel}
                </Text.Body>
            )}
        </Text.Heading>
    );
};
